export const FILE_RESET = "FILE_RESET";
export const FILE_SET_ERROR = "FILE_SET_ERROR";
export const FILE_SET_ELEMID = "FILE_SET_ELEMID";
export const FILE_SET_ITEMS = "FILE_SET_ITEMS";
export const FILE_TOGGLE_LOADING = "FILE_TOGGLE_LOADING";
